<template>
  <popover
    placement="bottom"
    width="300"
    trigger="click"
    popper-class="Notifications-popover"
  >
    <notifications-list />
    <badge
      slot="reference"
      :hidden="!count"
      :value="count"
      :max="99"
      class="NotificationsButton"
    >
      <el-button
        icon="bell"
        type="reset"
        class="NotificationsButton-button"
      ></el-button>
      <span class="NotificationsButton-label">{{ $t("layouts.notificationAlerts") }}</span>
    </badge>
  </popover>
</template>

<script>
import { Badge, Popover } from 'element-ui'
import { mapGetters } from 'vuex'

import NotificationsList from './NotificationsList.vue'

export default {
  name: 'NotificationsButton',
  components: {
    Badge,
    Popover,
    NotificationsList
  },
  computed: {
    ...mapGetters('notifications', ['unread']),
    count () {
      return (this.unread && this.unread.length) || 0
    }
  }
}
</script>
